import { ArrowLeftIcon } from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";

function UpdatePlaybackSettings() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [uuid] = useState(argumentData?.videoUuid || "");
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState("");
  const [ipAddress, setIpAddress] = useState(
    argumentData?.docking_station_ip_address || ""
  );
  const [namaPerangkat, setNamaPerangkat] = useState(
    argumentData?.nama_video || ""
  );
  const [namaBwc, setNamaBwc] = useState(argumentData?.nama_bwc || "");
  const [organizationId, setOrganizationId] = useState(
    argumentData?.docking_station_organization_id || ""
  );
  const [dataOrganization, setDataOrganization] = useState([]);

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.playback.playback_home);
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getDataOrganisasi = async () => {
    try {
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const response = await fetchApi().get(
        `/organization/get-list?${paramPage}&${paramSize}`
      );
      setDataOrganization(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataOrganization([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  const updateData = async () => {
    const formData = new FormData();
    formData.append("file", file);
    const reqBody = {
      nama_video: namaPerangkat,
      nama_bwc: namaBwc,
    };
    try {
      setIsLoading(true);
      const response = await fetchApi().put(`/video/update/${uuid}`, reqBody);
      setIsLoading(false);
      const videoTitle = reqBody.nama_video;
      handleSuccess(`Video ${videoTitle} berhasil diperbarui`);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData();
  };

  useEffect(() => {
    getDataOrganisasi();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Ubah Data Playback Video
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 gap-5 px-5 w-full">
            <div className="w-full">
              <label
                htmlFor="namaPerangkat"
                className="flex  text-sm font-medium leading-6"
              >
                Nama Videos
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="namaPerangkat"
                  name="namaPerangkat"
                  type="text"
                  disabled={isLoading}
                  value={namaPerangkat}
                  placeholder="Masukkan Nama Perangkat"
                  onChange={(e) => setNamaPerangkat(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="w-full">
              <label
                htmlFor="namaPerangkat"
                className="flex  text-sm font-medium leading-6"
              >
                Sumber/Kamera
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="namaPerangkat"
                  name="namaPerangkat"
                  type="text"
                  disabled={isLoading}
                  value={namaBwc}
                  placeholder="Masukkan Sumber/Kamera"
                  onChange={(e) => setNamaBwc(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          {/* <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="file_upload"
                className="flex  text-sm font-medium leading-6"
              >
                Upload Video
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="file_upload"
                  name="file_upload"
                  accept="video/*"
                  type="file"
                  disabled={isLoading}
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div> */}

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdatePlaybackSettings;
